import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("umb-market-src-set-image")
export class UmbMarketSrcSetImage extends LitElement {
  readonly IMG_SIZE = 64;

  @property({ type: String })
  src!: string;

  @property({ type: String })
  version = "";

  @property({ type: String })
  alt = "";

  #generateUrl(url: string, width: number, height: number) {
    return `${url}?width=${width}&height=${height}&rmode=pad${this.version.length > 0 ? `&v=${this.version}` : ''}`;
  }

  #generateSrcset(url: string) {
    return [2, 3].map((x) => `${this.#generateUrl(url, this.IMG_SIZE * x, this.IMG_SIZE * x)} ${x}x`).join(", ");
  }

  render() {
    return html`<img
      src=${this.#generateUrl(this.src, this.IMG_SIZE, this.IMG_SIZE)}
      srcset=${this.#generateSrcset(this.src)}
      width=${this.IMG_SIZE}
      height=${this.IMG_SIZE}
      alt=${this.alt}
    />`;
  }

  static styles = css`
    :host {
      display: flex;
      overflow: hidden;
    }
  `;
}
